var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6561 14.2114L21.3861 19.9414L19.8961 21.4314L14.1661 15.7014C13.0961 16.4714 11.8061 16.9414 10.3961 16.9414C6.80612 16.9414 3.89612 14.0314 3.89612 10.4414C3.89612 6.85141 6.80612 3.94141 10.3961 3.94141C13.9861 3.94141 16.8961 6.85141 16.8961 10.4414C16.8961 11.8514 16.4261 13.1414 15.6561 14.2114ZM10.3961 5.94141C7.90612 5.94141 5.89612 7.95141 5.89612 10.4414C5.89612 12.9314 7.90612 14.9414 10.3961 14.9414C12.8861 14.9414 14.8961 12.9314 14.8961 10.4414C14.8961 7.95141 12.8861 5.94141 10.3961 5.94141Z",
    fill: "#C4C6D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.059250bffef90933afd903ef193fe190.svg";
export { ForwardRef as ReactComponent };